const makeQueryParams = (queries) => {
  if (!queries) {
    return '';
  }

  return `?${queries}`;
};

export default makeQueryParams;
